/**
 * Supabase email confirmation links include hash params (access_token, type=signup).
 * If the redirect lands on /dashboard instead of /confirm, the user is auto-logged in
 * before we can sign them out. Send them to /confirm first.
 */
export function redirectEmailConfirmationToConfirmPage() {
    if (typeof window === 'undefined') {
        return;
    }

    const path = window.location.pathname;
    if (path === '/confirm' || path.endsWith('/confirm')) {
        return;
    }

    const hash = window.location.hash?.startsWith('#') ? window.location.hash.slice(1) : '';
    const search = window.location.search?.startsWith('?') ? window.location.search.slice(1) : '';
    const params = new URLSearchParams(hash || search);
    const type = params.get('type');

    if (type === 'signup' || type === 'email' || type === 'email_change') {
        window.location.replace(`/confirm${window.location.search}${window.location.hash}`);
    }
}
